import React from 'react'
import { Table } from 'react-bootstrap'

const AcuantAlert = (props) => {
  const data = props.processMetadata(props.obj).map((obj, i) => (
    <tr key={i}>
      <td style={{ width: '20%' }} className={'td-nowrap'}>
        <strong>{Object.keys(obj)[0]}</strong>
      </td>
      <td>{obj[Object.keys(obj)[0]]}</td>
    </tr>
  ))

  return (
    <Table striped bordered hover style={{ marginBottom: '0' }}>
      <tbody>{data}</tbody>
    </Table>
  )
}

export default AcuantAlert
